<template>
  <v-app>
    <v-main>
      <v-container>
        <v-layout justify-center>
          <v-flex xs12 sm12 md12 lg12 xl6>
            <v-card>
              <v-card-title class="pb-5">
                <v-btn to="/role" rounded color="#A5668B" class="text-white">
                  <v-icon>mdi-backspace-reverse-outline</v-icon>
                  بازگشت
                </v-btn>
                <v-spacer/>
                {{ $route.meta.title }}
                <v-spacer/>
                <v-btn @click="updatePack" color="#50858B" rounded class="text-white">
                  <v-icon>mdi-refresh</v-icon>
                  ذخیره
                </v-btn>
              </v-card-title>


              <v-card-text>

                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-text-field
                        v-model="title"
                        :error-messages="errors.title"
                        label="عنوان"
                        required
                        outlined
                        dense
                    >
                    </v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-text-field
                        v-model="title_fa"
                        :error-messages="errors.title_fa"
                        label="نام فارسی"
                        required
                        outlined
                        dense
                    >
                    </v-text-field>
                  </v-flex>
                </v-row>

                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <permission-picker
                        v-model="permissions"
                    ></permission-picker>
                  </v-flex>
                </v-row>

              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>

</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {SET_BREADCRUMB} from "../../../core/services/store/breadcrumbs.module";
import permissionPicker from "@/view/pages/pickers/permissionPicker";

export default {
  props: ['id'],
  components: {permissionPicker},

  data() {
    return {
      service: [],
      services: [],
      title: null,
      title_fa:null,
      expire: null,
      subline: {},
      permissions: {},
      tariff: {id: null},
      tariffs: [],
      owner: {id: null},
      owners: [
        {id: 1, name: 'فعال'},
        {id: 0, name: 'غیر فعال'}
      ],
      show: {id: null},
      shows: [
        {id: 1, name: 'فعال'},
        {id: 0, name: 'غیر فعال'}
      ],
      sortOrder: null,
      features: [],
      description: null,
      role: {id: null},
      roles: [],
      errors: [],
      rules: {
        title: [val => (val || '').length > 0 || 'فیلد عنوان الزامی می باشد.'],
        services: [(val) => val.length > 0 || 'فیلد سرویس الزامی می باشد.'],
        expire: [val => (val || '').length > 0 || 'فیلد تاریخ انقضا الزامی می باشد.'],
        permissions: [val => (val || []).length > 0 || 'فیلد دسترسی الزامی می باشد.'],
        tariff: [val => !!val || 'فیلد تعرفه الزامی می باشد.'],
      },
      url: 'admin/roles'

    }
  },

  mounted() {
    this.getPack();
  },
  created() {
    this.$store.dispatch(SET_BREADCRUMB, [{title: this.$route.meta.title}]);

  },
  methods: {
    getPack() {
      this.requestApiGet(`${this.url}/${this.id}`).then(({data}) => {
        this.title = data.name;
        this.title_fa = data.name_fa;
        this.permissions = data.permission;

      })
    },
    updatePack() {
      let checkedPermission = []
      for (let a in this.permissions) {
        checkedPermission.push(a)
      }
      this.requestApiPost(`${this.url}/${this.id}`, {
        name: this.title,
        name_fa:this.title_fa,
        permissions_id: checkedPermission,
        permissionStatus: this.permissions,
        _method: 'PUT'
      }).then(({data}) => {
        this.$toast.success('با موفقیت ویرایش شد.');
        this.$router.push({name: 'roles.index'});
      }).catch(({response}) => {
        this.errors = response;
      })
    }
  },


  computed: {
    ...mapGetters(["layoutConfig"]),
    config() {
      return this.layoutConfig();
    }
  },


}
</script>
